module.exports = __webpack_public_path__ + "img/geography.4e067812.svg";